import { FE_ENV } from '@/contracts/env';

/**
 * Resolve a frontend env var. Prefers runtime injection (`window.__ENV__`, set
 * at deploy by public/env-config.js) and falls back to Vite build-time env.
 * Names come from the frozen `contracts/env.ts`.
 */
function readEnv(name: string): string | undefined {
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[name]) {
    return window.__ENV__[name];
  }
  return (import.meta.env as Record<string, string | undefined>)[name];
}

export const env = {
  bffUrl: readEnv(FE_ENV.BFF_URL) ?? 'http://localhost:3021',
  backofficeLoginUrl: readEnv(FE_ENV.BACKOFFICE_LOGIN_URL) ?? 'http://localhost:8080/login',
};
